import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';
import { Trans } from '@lingui/macro';
import { Card } from '../card';
import { stories } from '@/components/overview';
import { useLingui } from '@lingui/react';

type StoriesNavigationProps = ComposableStyledComponentProps & {
  storyIds: string[];
};

const Root = styled('nav', {
  backgroundColor: '$white',
  display: 'grid',
  justifyContent: 'center',
  marginBlock: '$8',
  paddingInline: '$4',
});

const Stories = styled('ul', {
  display: 'grid',
  gridTemplateRows: 'repeat(3, 1fr)',
  gridGap: '$6',
  justifyContent: 'center',
  listStyleType: 'none',
  margin: 0,

  '@bp7': {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: '1fr',
  },
});

const StoryItem = styled('li', {
  padding: 0,
  '&::before': {
    content: '""',
  },
});

const NavigationTitle = styled('h2', {
  marginBlockEnd: '$6',
  textAlign: 'center',
});

export function StoriesNavigation({ storyIds, css }: StoriesNavigationProps) {
  const { i18n } = useLingui();

  const linkedStories = storyIds.flatMap((storyId) =>
    stories(i18n).filter((story) => story.id === storyId)
  );

  return (
    <Root css={css}>
      <NavigationTitle>
        <Trans id="common.microstory-stories-navigation">Explore other stories</Trans>
      </NavigationTitle>

      <Stories>
        {linkedStories.map((el) => (
          <StoryItem key={el.id}>
            <Card
              css={{
                fontSize: '$3',
                boxShadow: '0 0 1em 0 $colors$shadows',
                borderRadius: '$space$5',
                width: '17.5rem',
                height: 'calc(17.5rem * 1.4)',

                '@supports (aspect-ratio: 1 / 1.4)': {
                  aspectRatio: '1 / 1.4',
                },
              }}
              {...el}
            />
          </StoryItem>
        ))}
      </Stories>
    </Root>
  );
}
